import { PropsWithChildren } from 'react';
import { Analytics, AnalyticsProvider } from '@johnlewispartnership/wtr-website-analytics';

type AnalyticsSetupProps = PropsWithChildren;

const AnalyticsSetup = ({ children }: AnalyticsSetupProps) => {
  const dataLayer = (typeof window !== 'undefined' && window.dataLayer) || [];
  const analytics = new Analytics(dataLayer);

  return <AnalyticsProvider analytics={analytics}>{children}</AnalyticsProvider>;
};

export default AnalyticsSetup;
